import axios from 'axios';

/**
 * 写真共有URL生成のAPI
 */
export const createPictureShareUrl = (data: any) => {
  return axios
    .post('/api/v1/create/sharepicture', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真共有URLをメール送信するAPI
 */
export const sendPictureShareUrl = (sharePicturesId: number) => {
  return axios
    .post(`/api/v1/send/picture/${sharePicturesId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真共有状況（フォルダ単位）を取得するAPI
 */
export const getSharePictureGuestList = (folderId: number) => {
  return axios
    .get(`/api/v1/sharelist/picture/${folderId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真共有先編集のAPI
 */
export const editSharePictureGuest = (data: any) => {
  return axios
    .put('/api/v1/edit/sharepicture', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真共有先削除のAPI
 */
export const deleteSharePictureGuest = (sharePicturesId: number) => {
  return axios
    .post(`/api/v1/delete/sharepicture/${sharePicturesId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * URLに一致するフォルダの写真を取得するAPI
 */
export const getSharedPictureListByUrl = (uid: string, pwd: string) => {
  return axios
    .get(`/api/v1/sharepicture?uid=${uid}&pwd=${pwd}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真のサムネイルを取得するAPI（共有先）
 */
export const getThumbnail = (pictureId: number) => {
  return axios
    .get(`/api/v1/get/sharepicture/thumbnail/${pictureId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真の単一ダウンロード
 */
export const getPictureDownload = (pictureId: string, actionLog: boolean) => {
  return axios
    .get(`/api/v1/get/sharepicture/${pictureId}?action_log=${actionLog}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真のzipダウンロード
 */
export const getPicturesZip = (params: string) => {
  return axios
    .get(`/api/v1/get/sharepictures/zip?picture_ids_csv=${params}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真登録
 * @param data リクエストパラメータ
 */
export const createPictureByGuest = (data: any) => {
  return axios
    .post(`/api/v1/upload/picture`, data, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真更新
 */
export const editPictureDetail = (
  id: number,
  construct_id: number,
  picture_folder_id: number,
  shooting_date: string,
  description: string
) => {
  return axios
    .put(
      `/api/v1/edit/upload/picture/${id}`,
      {
        construct_id,
        picture_folder_id,
        shooting_date,
        description
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真削除
 */
export const deletePicture = (pictureId: number) => {
  return axios
    .post(`/api/v1/delete/upload/picture/${pictureId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
